import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import fileService from "../../../services/files/files.service";
import { HttpResponse } from "../../../services/base/base.dto";
import { FileDto } from "../../../services/files/files.dto";
import ItemTemplateForFileList from "./ItemTemplateForFileList";

interface ArfMultipleFileUploadProps {
  officialFileList: FileDto[] | undefined;
  setOfficialFileList: (files: FileDto[]) => void;
  isItDetailPage: boolean;
}

const ArfMultipleFileUpload = ({
  officialFileList,
  setOfficialFileList,
  isItDetailPage,
}: ArfMultipleFileUploadProps) => {
  const key = Math.random().toString();
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  const onTemplateSelectForFileList = (event: any) => {
    setLoading(true);
    let fd = new FormData();
    for (let file of event.files) {
      fd.append("file", file);
    }
    fileService
      .Add(fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        blockUI: true,
      })
      .then((response: HttpResponse<FileDto[]>) => {
        if (response.result) {
          setOfficialFileList([...officialFileList!, ...response.result]);
          event.options.clear();
          setLoading(false);
        }
      });
  };

  const onTemplateRemoveForFileList = (fileId: string) => {
    const fileToBeDeleted = officialFileList!.find((x) => x.id === fileId);
    if (fileToBeDeleted !== undefined) {
      fileService
        .Delete(fileToBeDeleted.id, {
          blockUI: true,
        })
        .then((response) => {
          let newOfficialFileList = officialFileList!.filter(
            (x) => x.id !== fileToBeDeleted.id
          );
          setOfficialFileList(newOfficialFileList);
        });
    }
  };

  const downloadPdf = (exampleFileId: string) => {
    window.open(
      `${process.env.REACT_APP_BASE_URL}files/${exampleFileId}?mode=inline`,
      "_blank"
    );
  };

  return (
    <div>
      {/* Dosya yükleme alanı - sadece detail sayfası değilse göster */}
      {!isItDetailPage && (
        <div
          style={{
            border: "2px dashed #dee2e6",
            borderRadius: "8px",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            cursor: "pointer",
            transition: "all 0.3s ease",
            minHeight: "200px",
            marginTop: "10px",
          }}
          onDragOver={(e) => {
            e.preventDefault();
            e.currentTarget.style.borderColor = "#007bff";
            e.currentTarget.style.backgroundColor = "#e3f2fd";
          }}
          onDragLeave={(e) => {
            e.preventDefault();
            e.currentTarget.style.borderColor = "#dee2e6";
            e.currentTarget.style.backgroundColor = "#f8f9fa";
          }}
          onDrop={(e) => {
            e.preventDefault();
            e.currentTarget.style.borderColor = "#dee2e6";
            e.currentTarget.style.backgroundColor = "#f8f9fa";

            const files = Array.from(e.dataTransfer.files);
            if (files.length > 0) {
              const event = { files, options: { clear: () => {} } };
              onTemplateSelectForFileList(event);
            }
          }}
          onClick={() => document.getElementById(key)?.click()}
        >
          <input
            id={key}
            type="file"
            multiple
            style={{ display: "none" }}
            onChange={(e) => {
              const files = Array.from(e.target.files || []);
              if (files.length > 0) {
                const event = { files, options: { clear: () => {} } };
                onTemplateSelectForFileList(event);
              }
              e.target.value = "";
            }}
          />

          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ marginBottom: "15px" }}>
              <i
                className="pi pi-upload"
                style={{ fontSize: "3rem", color: "#6c757d" }}
              ></i>
            </div>

            <h4 style={{ color: "#495057", marginBottom: "10px" }}>
              {t("DragDropFiles")}
            </h4>

            <p style={{ color: "#6c757d", marginBottom: "15px" }}>{t("Or")}</p>

            <button
              type="button"
              className="p-button p-button-outlined p-button-secondary"
              style={{
                padding: "8px 16px",
                border: "1px solid #6c757d",
                borderRadius: "4px",
                backgroundColor: "transparent",
                color: "#6c757d",
                cursor: "pointer",
              }}
              disabled={loading}
            >
              {loading ? t("Uploading") : t("SelectFiles")}
            </button>
          </div>
        </div>
      )}

      {/* Yüklenen dosyaların listesi */}
      {officialFileList && officialFileList.length > 0 ? (
        <div
          className="uploaded-files-list"
          style={{ marginTop: isItDetailPage ? "0" : "0" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
              padding: "10px 0",
              borderBottom: "1px solid #dee2e6",
            }}
          >
            <h5 style={{ margin: "0", color: "#495057" }}>
              {t("UploadedFiles")} ({officialFileList.length})
            </h5>
          </div>

          <ItemTemplateForFileList
            fileList={officialFileList}
            onTemplateRemoveForFileList={onTemplateRemoveForFileList}
            downloadPdf={downloadPdf}
            isItDetailPage={isItDetailPage}
          />
        </div>
      ) : officialFileList && officialFileList.length === 0 && isItDetailPage ? (
        <div
          style={{
            textAlign: "center",
            padding: "30px 20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
            marginTop: isItDetailPage ? "10px" : "0",
          }}
        >
          <i
            className="pi pi-file"
            style={{
              fontSize: "2rem",
              color: "#6c757d",
              marginBottom: "10px",
            }}
          ></i>
          <p
            style={{
              color: "#6c757d",
              margin: "0",
              fontSize: "14px",
            }}
          >
            {t("NoFilesFound")}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default ArfMultipleFileUpload;
